import React from 'react';
import { useTranslation } from 'react-i18next';
import type { DiaryNote } from '@/types/diary';
import { linkifyText } from '@/utils/html';

interface Props {
  note: DiaryNote;
}

export const TeacherMessageItem: React.FC<Props> = ({ note }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 px-4 py-[11px]">
      <div className="flex flex-wrap items-center gap-4">
        <span className="text-subhead-14 text-foreground">
          {note.authorName}
        </span>

        <span className="text-caption-12 shrink-0 rounded-xl border border-transparent bg-yellow-soft px-2 py-0.5 text-warning contrast:border-border">
          {t('diary.notes.teacherMessage')}
        </span>
      </div>

      <p
        className="rich-text text-body-14 text-foreground"
        dangerouslySetInnerHTML={{ __html: linkifyText(note.text) }}
      />
    </div>
  );
};
